// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O1pn","index":"styles_index__2PeGL"};